import { YeatiesAcceptedCheck } from "@/features/card/components/OnboardingModal/OnBoardingModalElements/OnboardingModalSteps/YeatiesConsent/YeatiesAcceptedCheck";
import { YEATIES_ACCEPTED_TITLE } from "@/features/card/configs/yeatiesConsent.config";
import type { YeatiesConsent } from "@/features/purchasePoints";
import { H2 } from "@/shared/ui/typographies/h2";
import { cn } from "@/shared/utils/style.util";

type CardActivationSuccessSlideHeaderProps = { consent: YeatiesConsent | null };

export const CardActivationSuccessSlideHeader = ({ consent }: CardActivationSuccessSlideHeaderProps) => {
  const isAccepted = consent === "accepted";

  return (
    <H2
      data-testid="card-activation-success-slide"
      className={cn(
        "text-success text-pretty space-y-4 animate-fade-in text-center",
        isAccepted && "flex items-center justify-center gap-2",
      )}
    >
      {isAccepted && <YeatiesAcceptedCheck />}
      {isAccepted ? YEATIES_ACCEPTED_TITLE : "Carte activée avec succès !"}
    </H2>
  );
};
